import React from 'react'
import { Link } from 'react-router-dom'
import Mailicon from '../../assets/images/mail_icon.png'
import Phoneicon from '../../assets/images/phone_icon.png'
import Locationicon from '../../assets/images/location_icon.png'
import ContactInfo from '../../data/contactData.json'

function Contactblock() {
    return (
        <>
            <section className="contact_section">
                <div className="container">
                    <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
                        <span className="title_badge">Contact</span>
                        <h2>
                        Ce zici, <span>ținem legătura?</span>
                        </h2>
                        <p>
                            Iți stam la dispoziție pentru orice întrebări sau probleme technice
                        </p>
                    </div>
                    <ul className="contact_listing">
                        <li data-aos="fade-up" data-aos-duration={1500}>
                            <span className="icon">
                                <img src={Mailicon} alt="image" />
                            </span>
                            <span className="lable">Trimite-ne un email</span>
                            <Link to={`mailto:${ContactInfo.emailAddress}`}>{ContactInfo.emailAddressText}</Link>
                        </li>
                        <li data-aos="fade-up" data-aos-duration={1500} data-aos-delay={150}>
                            <span className="icon">
                                <img src={Phoneicon} alt="image" />
                            </span>
                            <span className="lable">Apelează-ne</span>
                            <Link to={`tel:${ContactInfo.phoneNumber}`}>{ContactInfo.phoneNumberText}</Link>
                        </li>
                        <li data-aos="fade-up" data-aos-duration={1500} data-aos-delay={300}>
                            <span className="icon">
                                <img src={Locationicon} alt="image" />
                            </span>
                            <span className="lable">Unde a început totul</span>
                            <Link target="_blank" to={`${ContactInfo.physicalAddressMaps}`}>
                                {ContactInfo.physicalAddress}
                            </Link>
                        </li>
                    </ul>
                </div>
            </section>
        </>
    )
}

export default Contactblock